class FaqNavComponent extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('a');
    this.headings = document.querySelectorAll(`.${this.dataset.toObserve} h2`);
    this.offset = parseInt(getComputedStyle(document.querySelector('html')).scrollPaddingTop, 10);
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.links.forEach((link) => { link.addEventListener('click', this.handleClick.bind(this)) });
  }

  handleScroll() {
    let currentTop = window.scrollY + this.offset + 10;
    this.headings.forEach((heading) => {
      if (currentTop >= heading.offsetTop && currentTop < heading.offsetTop + heading.offsetHeight) {
        this.links.forEach((link) => {
          link.classList.remove('is-active');
          if (heading.id === link.hash.slice(1)) {
            link.classList.add('is-active');
          }
        });
      }
    })
  }

  handleClick(event) {
    event.preventDefault();
    let target = document.querySelector(event.target.hash);
    if (target) {
      window.scrollTo({
        top: target.offsetTop - this.offset,
        behavior: 'smooth'
      });
    }
    window.location.hash = event.target.hash;
  }
}

customElements.define('faq-nav', FaqNavComponent);